import { useEffect, useState } from "react";
import api from "../../api/axios";
import { Link } from "react-router-dom";

export default function PropertyAvailableBookingList() {
  const [properties, setProperties] = useState([]);

  useEffect(() => {
    api
      .get("/api/properties")
      .then((res) => {
        const available = res.data.data.filter((p) =>
          p.units?.some((u) => u?.status?.status_type === "available")
        );
        setProperties(available);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <div className="container">
      <h2 className="text-center fw-bold mb-4">
        Available Properties to book or buy
      </h2>

      <div className="row g-4">
        {properties.map((p) => (
          <div className="col-md-4" key={p.id}>
            <Link
              to={`/properties_available/${p.id}`}
              className="text-decoration-none text-dark"
            >
              <div className="card shadow-sm border-0 rounded-4 property-card h-100">
                
                {/* 🔥 Auto Image Slider */}
                <AutoImageSlider photos={p.photos} />

                <div className="card-body">
                  <h5 className="card-title fw-bold">{p.name}</h5>

                  <p className="text-muted mb-1">
                    Floor: {p.total_floors ?? "N/A"}
                  </p>

                  <p className="text-muted mb-1">
                    {p.location?.road_number}, Block {p.location?.block},{" "}
                    {p.location?.area}, {p.location?.city}
                  </p>

                  <p className="text-muted mb-1">
                    Type: {p.type?.name}
                  </p>

                  <p className="fw-semibold text-success mt-2">
                    Available Units:{" "}
                    {
                      p.units.filter(
                        (u) => u?.status?.status_type === "available"
                      ).length
                    }
                  </p>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      {/* Extra CSS */}
      <style>{`
        .property-card {
          transition: 0.3s;
        }
        .property-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 6px 20px rgba(0,0,0,0.15);
        }
      `}</style>
    </div>
  );
}

/* ============================= */
/* 🔥 Auto Image Slider Component */
/* ============================= */

function AutoImageSlider({ photos = [] }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!photos || photos.length === 0) return;

    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % photos.length);
    }, 2500); // auto change every 2.5s

    return () => clearInterval(interval);
  }, [photos]);

  if (!photos || photos.length === 0) {
    return (
      <div
        className="d-flex align-items-center justify-content-center bg-light rounded-top-4"
        style={{ height: "220px" }}
      >
        <span className="text-muted">No Photos Available</span>
      </div>
    );
  }

  const photo = photos[index];

  return (
    <img
      src={
        photo.file_path?.startsWith("http")
          ? photo.file_path
          : `${api.defaults.baseURL}/${photo.file_path}`
      }
      alt="property"
      className="w-100 rounded-top-4"
      style={{
        height: "220px",
        objectFit: "cover",
        transition: "0.5s ease-in-out",
      }}
    />
  );
}